/* eslint-disable @typescript-eslint/no-deprecated */
import { createContext, useContext } from 'react';

import type { PanelName } from '../page/page-types.js';

/** @internal */
export const panelContext = createContext<{
  name: PanelName;
} | null>(null);

/** @internal */
export function usePanelContext() {
  return useContext(panelContext);
}
